<template>
  <div>
    <label
      v-if="title != 'hide'"
      v-bind:class="{
        'text-danger': current.errors && current.errors.categoria,
      }"
      >{{ title }}</label
    >
    <v-select
      label="nombre"
      v-model="current.categoria"
      :disabled="disabled"
      :filterable="false"
      :options="categoria"      
      @search="onSearch"
      @input="change($event)"
      placeholder="Categorías..."
    >
      <template slot="no-options">Categoría...</template>
      <template slot="option" slot-scope="option">
        <div class="selected d-center">
          {{ option.codigo }} - {{ option.nombre }}
        </div>
      </template>
      <template slot="selected-option" slot-scope="option">
        <div class="selected d-center">
          {{ option.codigo }} - {{ option.nombre }}
        </div>
      </template>
    </v-select>
    <small
      v-if="current.errors && current.errors.categoria"
      class="form-text text-danger"
      >{{ current.errors.categoria }}</small
    >
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    current: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
      required: false,
    },

    title: {
      type: String,
      default: "Categoría",
    },     
    /**
     *sin_borde en estado true desde componente padre 
     *elimina bordes, margin y padding, para poder insertar 
     *el componente en una tabla y que tome el tamaño de la celda     
     *que lo contiene
     */
     sin_borde: {
      type:Boolean,
      default:false
    }
  },
  computed: {
    ...mapGetters({
      categoria: "catalogos/categorias",
    }),
  },
  mounted() {
    this.$store.dispatch("catalogos/categorias", {
      activo: true,
      page: 1,
      quitar_paginacion: true,
    });
  },
  methods: {
    change() {
      this.$emit("change", event);
    },
    onSearch(search, loading) {
      loading(true);
      this.search(loading, search, this);
    },
    search: _.debounce((loading, search, vm) => {
      if (search == "" || search == null) {
        loading(false);
        return;
      }
      let that = this;
      vm.$store.dispatch("catalogos/categorias", {
        page: 1,
        quitar_paginacion: true,
        "filter[search]": search,
      });
      // vm.proveedores = that.tiendas;
      loading(false);
      /*ProveedorService.fetch().then(res => {
        vm.proveedores = res.data;
        
      });*/
    }, 350),
  },
};
</script>

<style>
  .sin_borde{
    border: none !important;
    padding: 0 !important;
    margin: 0 !important;
    width: 100% !important;
    height: 100% !important;
    box-shadow: none !important;
  }
</style>